import cn from 'classnames';

import styles from './ThirdLevelCategories.module.scss';

export default function ThirdLevelCategories({ categories, selectedCategoryId, onClick }) {
  if (!categories.length) return null;
  const categoriesText = {
    el: {
      all: 'Όλα',
    },
  };
  return (
    <div className={styles.container}>
      <button
        className={cn({
          [styles.button]: selectedCategoryId !== '0',
          [styles.buttonSelected]: selectedCategoryId === '0',
        })}
        type="button"
        onClick={() => onClick('0', true)}
      >
        {categoriesText.el.all}
      </button>
      {categories.map(c => {
        if (!c.numberOfProductsToDisplay) return null;
        return (
          <button
            key={c._id}
            className={cn({
              [styles.button]: c._id !== selectedCategoryId,
              [styles.buttonSelected]: c._id === selectedCategoryId,
            })}
            type="button"
            onClick={() => onClick(c._id, false)}
          >
            {c.name}
          </button>
        );
      })}
    </div>
  );
}
